// src/upload/directUpload.ts
import axios from "axios";
var DirectUploadError = class extends Error {
  constructor(message, status, code) {
    super(message);
    this.name = "DirectUploadError";
    this.status = status;
    this.code = code;
  }
};
var uploadClient = axios.create({
  withCredentials: false,
  timeout: 0
});
var s3ErrorCode = (body) => {
  if (typeof body !== "string") return void 0;
  return /<Code>([^<]+)<\/Code>/.exec(body)?.[1];
};
var postDirectUpload = async ({
  url,
  fields,
  file,
  onProgress,
  signal
}) => {
  const form = new FormData();
  for (const [name, value] of Object.entries(fields)) {
    form.append(name, value);
  }
  form.append("file", file);
  try {
    await uploadClient.post(url, form, { onUploadProgress: onProgress, signal });
  } catch (error) {
    const response = error.response;
    throw new DirectUploadError(
      error.message ?? "Direct upload failed",
      response?.status,
      s3ErrorCode(response?.data)
    );
  }
};
var uploadWithConcurrency = async (items, limit, task) => {
  const results = new Array(items.length);
  let next = 0;
  const worker = async () => {
    for (; ; ) {
      const index = next++;
      if (index >= items.length) return;
      results[index] = await task(items[index], index);
    }
  };
  await Promise.all(
    Array.from({ length: Math.min(Math.max(limit, 1), items.length) }, () => worker())
  );
  return results;
};

export {
  DirectUploadError,
  postDirectUpload,
  uploadWithConcurrency
};
